import { Link as NextLink } from '@framework/router/Next/Link';
import noop from 'lodash/noop';

import DowloadFileLink from './DowloadFileLink';
import {
  IArticleRelatedDealWithUrl,
  ICompanyWithUrl,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Article';
import { IAttachmentWithName } from '@/creditflowresearch/domain/vo/ArticlesAndStats/IAttachment';

import styles from '../styles.module.scss';

interface IProps {
  label: string,
  dataTest: string,
  onClick?: (item: { displayName: string, uploadId: string, name: string }) => void,
  isDownload?: boolean,
  collection: ICompanyWithUrl[] | IAttachmentWithName[] | IArticleRelatedDealWithUrl[],
}

const RelatedDataSection = ({
  label,
  dataTest,
  collection,
  onClick = noop,
  isDownload = false,
}: IProps) => {
  if (collection.length === 0) {
    return null;
  }
  return (
    <div className={ styles.relatedDataSection } data-test={ dataTest }>
      <p className={ styles.relatedDataSectionLabel } data-test="relatedLabel">{ label }</p>
      <div className={ styles.relatedDataSectionList } data-test="relatedList">
        { collection.map((item) => (
          <div key={ item.url || item.name } data-test="relatedItem">
            { isDownload ? (
              <DowloadFileLink onClick={ onClick } item={ item } dataTest="relatedItem" />
            ) : (
              <NextLink
                to={ item.url }
                className={ styles.relatedDataSectionLink }
                target="_blank"
                dataTest="relatedItemLink"
              >
                { item.name }
              </NextLink>
            ) }
          </div>
        )) }
      </div>
    </div>
  );
};
export default RelatedDataSection;
